import { useQuery } from "@tanstack/react-query";
import { API_HOST } from "@/core/variables";
import { User } from "@/model";
import authRepository from "@/repository/authRepository";


const getData = async () => {
    try {
        const res = await authRepository.getProfile();
        return res.data?.data;
    } catch (error) {
        window.location.replace(`${API_HOST}/v1/auth/login?client_redirect_uri=${document.URL}`);
    }
};

export const useProfile = () => {
    return useQuery<User>({
        queryKey: ["profile"],
        queryFn: async () => getData(),
        retry: false
    });
};
